let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eIifx")).then(() => parcelRequire('7vE0x'));